const component = "site-section-appliance-card";

export const siteSectionApplianceCard = {
  component,
  applianceIcon: `${component}/appliance-icon`,
  applianceName: `${component}/appliance-name`,
  applianceId: `${component}/appliance-id`,
} as const;
